import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs';
import { CommonService } from 'src/app/service/common.service';
import { Destroy } from 'src/app/service/destroy';
import { environment } from 'src/environments/environment';

interface PolicyItem {
  id: string;
  title: string;
  url: string;
}

@Component({
  selector: 'app-legal',
  templateUrl: './legal.component.html',
  styleUrls: ['./legal.component.css'],
  imports: [CommonModule],
  providers: [Destroy]
})
export class LegalComponent implements OnInit {
  policies: PolicyItem[] = [];

  constructor(private route: ActivatedRoute, private sanitizer: DomSanitizer, private commonService: CommonService, private destroy$: Destroy) {}

  ngOnInit(): void {
    this.policies = [
    { 
      id: 'privacy', 
      title: 'Privacy Policy', 
      url: `${environment.domain}/privacy-policy`
    },
    { 
      id: 'terms', 
      title: 'Terms & Conditions', 
      url: `${environment.domain}/terms-conditions`
    },
    { 
      id: 'insurance', 
      title: 'Insurance', 
      url: `${environment.domain}/insurance`
    },
    { 
      id: 'cancellation', 
      title: 'Cancellation Policy', 
      url: `${environment.domain}/cancellation-policy`
    }
  ];
  }

  /**
   * Open policy URL in a new tab
   */
  openPolicy(url: string): void {
    window.open(url, '_blank');
  }
}
